import { roundOff } from '../../../Components/helper';

export default function useMdCalculationHooks() {
  const calculateMd = async (state) => {
    let cloneState = state;
    let mdSalesUnits = 0;
    let mdSalesValue = 0;
    let mdSlsMix = 0;
    const { fpSalesUnits, fpSlsMix, markDown, rrpValue } = cloneState;
    const rrp = rrpValue?.value;
    const fpSaleUnit = Number(fpSalesUnits) || 0;
    const fpSlsMixValue = (Number(fpSlsMix?.value) || 0) / 100;
    mdSalesUnits = Math.round(fpSaleUnit * (1 - fpSlsMixValue));
    const mdPerVal = (Number(markDown?.value) || 0) / 100;
    mdSalesValue = roundOff(mdSalesUnits * Number(rrp) * mdPerVal, 2);
    mdSlsMix = roundOff((1 - fpSlsMixValue) * 100, 2);
    cloneState = {
      ...cloneState,
      mdSalesUnits,
      mdSalesValue,
      mdSlsMix,
    };
    return cloneState;
  };

  return { calculateMd };
}
